import { trackEventBasic } from '@/services/AnalyticsWrapper'

export default {
  namespaced: true,

  state: {
    hit_image: false,
    hit_code: false,
    hit_video: false,
    hit_link: false,
    social_links: false,
    hit_post_bar: false,
    edit_profile: false,
    edit_alternative_email: false
  },

  mutations: {
    show(state, modal_name) {
      state[modal_name] = true
      trackEventBasic('Modals', 'opened', modal_name)
    },

    hide(state, modal_name) {
      state[modal_name] = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Modals.js